import React, { FC } from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { IncidentSubClassification } from '@models/Incident';

import { RealEstateDefectFormKey } from '../../MessageForms.types';
import { BuildingDefectCommonForm } from '../components/BuildingDefectCommonForm';

import { BuildingDefectCommonAreas } from './BuildingDefectCommonAreas';

export * from './BuildingDefectCommonAreas';

export const buildingDefectForms: Record<
  RealEstateDefectFormKey,
  FC<ParsedEntry<IWidget>>
> = {
  [RealEstateDefectFormKey.DEFECT_REAL_ESTATE_PESTS]: (props) => (
    <BuildingDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.PEST_CONTROL}
    />
  ),
  [RealEstateDefectFormKey.DEFECT_REAL_ESTATE_OUTDOOR_CARE]: (props) => (
    <BuildingDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.OUTDOOR_MAINTENANCE}
    />
  ),
  [RealEstateDefectFormKey.DEFECT_REAL_ESTATE_CLEANLINESS]: (props) => (
    <BuildingDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.CLEANING}
    />
  ),
  [RealEstateDefectFormKey.DEFECT_REAL_ESTATE_WASTE_BIN_CLEANLINESS]: (
    props
  ) => (
    <BuildingDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.GARBAGE_AREA_MAINTENANCE}
    />
  ),
  [RealEstateDefectFormKey.DEFECT_REAL_ESTATE_PARKING]: (props) => (
    <BuildingDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.PARKING_ISSUE}
    />
  ),
  [RealEstateDefectFormKey.DEFECT_REAL_ESTATE_COMMON_SPACES]:
    BuildingDefectCommonAreas,
  [RealEstateDefectFormKey.DEFECT_REAL_ESTATE_OTHER]: (props) => (
    <BuildingDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.OTHER_PUBLIC_DEFECT}
    />
  ),
};
